import cnchar from 'cnchar'
import { MOMENT_TIME } from '../../momenttime'
import { FORMAT } from '../core/format'
import { UTILS } from '../../utils'
import { PAIPAN } from '../core/paipan'

/**
 * 记录模块数据管理类
 */
var RECORD_DATA_MANAGER = {

    // 初始化列表单个数据
    getRecordDataByData(data, groupData) {
        var recordData = {};
        // 基础数据
        recordData.id = data.id;
        recordData.name = data.f_name.slice(0, 15);
        recordData.firstL = this.getFirstLetterByName(data.f_name);
        recordData.time = data.f_time;

        // 处理分组数据:分组id及分组名
        var groupId = data['f_group'];
        var index = UTILS.getIdIndexInObjectArray(groupData, groupId);
        recordData.group = groupData[index] ? groupData[index]['f_name'].slice(0, 17) : "未分组";
        recordData.groupId = groupId;

        recordData.pipan = data.pipan;
        recordData.nunpan = data.nunpan;
        recordData.hb = data.hb;
        recordData.reminder = data.reminder;
        recordData.sex = (data.sex == 0 ? "男" : "女");
        recordData.situation = data.situation;
        recordData.birthday = data.birthday;
        recordData.createtime = data.createtime;
        recordData.glance_time = data.glance_time;
        recordData.toBaike = data.toBaike;
        
        // UI数据:Record列表
        var starttime = data.real_time == 0 ? data.birthdayDate : data.realDate;
        // recordData.dateStr = data.unknown == 1 ? MOMENT_TIME.getFormateTimeYMDByTimeStamp(starttime * 1000) : MOMENT_TIME.getFormateTimeYMDHmByTimeStamp(starttime * 1000);
        recordData.dateStr = starttime.slice(0, -3);
        recordData.eightWordArr = FORMAT.getEightWordArrByData(data.unknown, data);
        recordData.selected = false;

        // 保存天干地支数组数据
        recordData.tg = [data.tg_1, data.tg_2, data.tg_3, data.tg_4];
        recordData.dz = [data.dz_1, data.dz_2, data.dz_3, data.dz_4];

        // 保存label数据
        recordData.label = data.label;
        recordData.remark = data.remark;

        return recordData;
    },

    // 获取最近列表数据
    getRecordRecentlyData(recordArr, groupData) {
        var resultList = [], largestGlanceTime = 0, originalData = {};
        for(var data of recordArr){
            originalData[data.id] = data;
            largestGlanceTime = data.glance_time >= largestGlanceTime ? data.glance_time : largestGlanceTime;
            resultList.push(this.getRecordDataByData(data, groupData));
        }
        // 服务器有处理过排序
        resultList.sort((a, b) => {return b.glance_time - a.glance_time});
        return {
            'list': resultList,
            'original': originalData,
            'largest': largestGlanceTime
        };
    },

    // 获取全部列表数据
    getRecordListData(recordArr, groupData) {

        // console.log('初始化数据------', recordArr);

        // 处理列表数据
        var originalData = {};
        var resultList = [];
        var tempTime = 0;
        for (var i = 0; i < recordArr.length; i++) {
            // 暂存列表的服务端数据将id保存为key:用于根据id快速查找
            originalData[recordArr[i].id] = recordArr[i];
            // 暂存最大f_time值
            tempTime = recordArr[i].f_time > tempTime ? recordArr[i].f_time : tempTime;
            // 转换UI数据
            var data = this.getRecordDataByData(recordArr[i], groupData);
            resultList.push(data);
            
            // 处理分组数据:给分组列表里的group_list字段添加RecordData元素
            var index = UTILS.getIdIndexInObjectArray(groupData, recordArr[i].f_group);
            if (groupData[index]) {
                groupData[index]['group_list'].push(data);
            }
        }

        // 处理字母开头的数据
        // var letterData = this.getRecordLetterData(resultList);
        var letterData = this.getRecordLetterListData(resultList);
        var result = {
            "biggest": tempTime,
            "original": originalData,
            "result": resultList,
            'letter': letterData,
            'group': groupData
        }
        // console.log('getRecordListData------', result);
        return result;
    },

    getRecordLetterData(recordList) {
        // 保存字母索引表的数据
        var letterObject = {};
        for (var i = 0; i < recordList.length; i++) {
            var firstL = this.getFirstLetterByName(recordList[i].name);
            if (!letterObject[firstL]) {
                letterObject[firstL] = [];
            }
            letterObject[firstL].push(recordList[i]);
        }
        //Todo:对leterObject进行排序:用更高效的方式
        var propArr = [];
        for (var prop in letterObject) {
            propArr.push(prop)
        }
        propArr.sort();
        var newLetterObject = {};
        for (var j = 0; j < propArr.length; j++) {
            newLetterObject[propArr[j]] = letterObject[propArr[j]];
        }
        var result = {
            'letterArr': propArr,
            'letterObject': newLetterObject
        };
        return result;
    },

    // 获取名字的首字母
    getFirstLetterByName(name) {
        var firstL = name.spell().slice(0, 1);
        // console.log('firstL-----', name, firstL)
        if(/^[a-zA-Z]+$/.test(firstL)){
            // 字母开头命名
            firstL = firstL.toUpperCase();
        }else{
            // 非字母开头命名
            firstL = '#';
        }
        return firstL;
    },

    // 根据列表数据获取首字母列表数据
    getRecordLetterListData(recordList) {
        var letterList = [];
        for (var i = 0; i < recordList.length; i++) {
            // 根据recordList获取letterList
            var firstL = this.getFirstLetterByName(recordList[i].name);
            if(letterList.indexOf(firstL) == -1){
                letterList.push(firstL)
            }
        }
        letterList.sort((a, b) => {return a.localeCompare(b)})
        return letterList;
    },

    // 更新列表以id为key值的对象数据
    updateRecordOriginalData(origiData, newData){
        for(var keys in newData) {
            // 第一次拉取的时候
            if(!origiData[keys]){
                origiData[keys] = newData[keys];
            }else{
                origiData[keys] = Object.assign({}, newData[keys]);
            }
        }
        return origiData;
    },

    // 更新列表的数组数据
    updateRecordListData(origiList, newList) {
        // 第一次拉取的时候
        if(origiList.length == 0){
            origiList = origiList.concat(newList);
        }else{
            for(var data of newList) {
                var index = UTILS.getIdIndexInObjectArray(origiList, data.id);
                if(index != -1){
                    origiList[index] = Object.assign({}, data);
                }else{
                    origiList.push(data);
                }
                // console.log('updateRecordListData--------', data);
            }
        }
        // 数据以开头字母的顺序排序
        origiList.sort((a, b) => {return a.firstL.localeCompare(b.firstL)})
        return origiList;
    },

    getResultListSort(recordList) {
        var oneList = [], secondList = [];
        for(var data of recordList) {
            if(data.firstL == '#'){
                oneList.push(data);
            }else{
                secondList.push(data)
            }
        }
        oneList.sort((a, b) => {return parseInt(a.name) - parseInt(b.name)});
        secondList.sort((a, b) => {return a.firstL.localeCompare(b.firstL)});
        // console.log('getResultListSort-------', recordList, oneList, secondList);
        var resultList = oneList.concat(secondList);
        return resultList;
    },

    // 更新列表开头字母的数组数据
    updateRecordLetterList(origiList, newList) {
        // 第一次拉取的时候
        if(origiList.length == 0){
            origiList = origiList.concat(newList);
        }else {
            for(var letter of newList) {
                if(origiList.indexOf(letter) == -1){
                    origiList.push(letter);
                }
                // console.log('updateRecordLetterList--------', letter);
            }
        }
        origiList.sort();
        return origiList;
    },

    // 更新列表以开头字母为key的对象数据
    updateRecordLetterData(origiData, newData){
        for(var keys in newData) {
            // 第一次拉取的时候
            if(!origiData[keys]){
                origiData[keys] = newData[keys];
            }else{
                for(var data of newData[keys]){
                    var index = UTILS.getIdIndexInObjectArray(origiData[keys], data.id);
                    if(index != -1){
                        // 更新已有数据
                        origiData[keys][index] = Object.assign({}, data);
                    }else{
                        // 新增数据
                        origiData[keys].push(data);
                    }
                }
                // console.log('updateRecordLetterList--------', keys, newData[keys]);
            }
        }
        return origiData;
    },

    // 根据首字母获取该RecordData的index值
    getRecordDataIndexByFirstL(origiData, firstL) {
        for (var recordData of origiData) {
            if(recordData.firstL == firstL){
                return origiData.indexOf(recordData);
            }
        }
        return -1;
    },

    // 删除排盘列表数据
    deleteRecordListData(origiData, deleteArr) {
        for(var deleteId of deleteArr) {
            for(var recordData of origiData) {
                var index = origiData.indexOf(recordData);
                if(recordData.id == deleteId) {
                    origiData.splice(index, 1);
                }
            }
        }
        var result = {
            'listData': origiData,
            'letter': this.getRecordLetterListData(origiData)
        };
        return result;
    },

    // 更新排盘列表数据的分组名
    updateRecordListGroupName(origiData, groupId, groupName) {
        for (var recordData of origiData) {
            if(recordData.groupId == groupId){
                recordData.group = groupName;
            }
        }
        return origiData;
    },

    // 获取过滤后的排盘列表数据
    getFilterRecordData(origiData, key, value) {
        var filterList = origiData.filter(data => data[key] == value);
        filterList.sort((a, b) => {return a.firstL.localeCompare(b.firstL)});
        return filterList;
    },

    // 根据数据Id获取数据的分组Id
    getRecordGroupIdById(origiData, recordId) {
        if(origiData[recordId]) {
            return origiData[recordId]['f_group'];
        }
        return 0;
    },

    /**
     * 根据当前输入的八字信息查看是否有重复四柱的八字数据
     * @param {列表数据} listData 
     * @param {输入表单数据} formData 
     */
    getRecordListSameSiZhuList(listData, formData) {
        var resultList = [];
        if(formData.birthday == '') {
            return resultList;
        }
        var starttime = MOMENT_TIME.getUnixTimeByTimeStr(formData.birthday);
        var baziData = PAIPAN.GetInfo(formData.sex, starttime, formData.zwzs);
        listData.forEach(element => {
            if(element.tg.join('') == baziData.tg.join('') && element.dz.join('') == baziData.dz.join('')) {
                resultList.push(element);
            }
        });
        console.log('getRecordListSameSiZhuList-------', formData, resultList);
        return resultList;
    }

}

export {
    RECORD_DATA_MANAGER
}